module.exports = __webpack_public_path__ + "static/media/Places-13.a56dab00.jpg";